// extracted by mini-css-extract-plugin
export var borderRadius = "_ex-4";
export var large = "_ex-3";
export var logoContainer = "_ex-0";
export var nameLogo = "_ex-2";
export var small = "_ex-1";